import { GenericAccountStateTypes } from "@enums/generic-account-state-types";
import { AxnCompany } from "@idw-types/data/reference-data/axn";

export enum OrganizationsActionTypes {
    // Organizations
    SET_ORGANIZATIONS_LOADING = "SET_ORGANIZATIONS_LOADING",
    SET_ORGANIZATIONS = "SET_ORGANIZATIONS",
    ADD_ORGANIZATION = "ADD_ORGANIZATION",
    UPDATE_ORGANIZATIONS = "UPDATE_ORGANIZATIONS"
}

// Organizations
type SetOrganizationsLoadingAction = {
    type: OrganizationsActionTypes.SET_ORGANIZATIONS_LOADING;
    payload: { isLoading: boolean; }
};

export const setOrganizationsLoading = (isLoading: boolean): SetOrganizationsLoadingAction => ({
    type: OrganizationsActionTypes.SET_ORGANIZATIONS_LOADING,
    payload: { isLoading }
});

type SetOrganizationsAction = {
    type: OrganizationsActionTypes.SET_ORGANIZATIONS;
    payload: { axnCompanies: Array<AxnCompany>; }
}

export const setOrganizations = (axnCompanies: Array<AxnCompany>): SetOrganizationsAction => ({
    type: OrganizationsActionTypes.SET_ORGANIZATIONS,
    payload: { axnCompanies }
});

type AddOrganizationAction = {
    type: OrganizationsActionTypes.ADD_ORGANIZATION;
    payload: { axnCompany: AxnCompany };
}

export const addOrganization = (axnCompany: AxnCompany): AddOrganizationAction => ({
    type: OrganizationsActionTypes.ADD_ORGANIZATION,
    payload: { axnCompany }
});

type UpdateOrganizationsAction = {
    type: OrganizationsActionTypes.UPDATE_ORGANIZATIONS;
    payload: { updatedAxnCompany: AxnCompany, accountState: GenericAccountStateTypes };
};

export const updateOrganizations = (
    updatedAxnCompany: AxnCompany,
    accountState: GenericAccountStateTypes
): UpdateOrganizationsAction => ({
    type: OrganizationsActionTypes.UPDATE_ORGANIZATIONS,
    payload: { updatedAxnCompany, accountState }
});

export type OrganizationsActions =
    // Organizations
    SetOrganizationsLoadingAction |
    SetOrganizationsAction |
    AddOrganizationAction | 
    UpdateOrganizationsAction;